"use strict";
// Base weather data model - basinterface för all väderdata
Object.defineProperty(exports, "__esModule", { value: true });
